<header>
  <mat-toolbar>
    <h1>Firstmac</h1>

    <nav>
      <button mat-button routerLink="/" routerLinkActive="active">Home</button>
      <button mat-button [matMenuTriggerFor]="menu">Wizards</button>
      <mat-menu #menu="matMenu">
        <!-- <button mat-menu-item routerLink="/application/business-auto" routerLinkActive="active">Business Auto Application</button> -->
        <button mat-menu-item routerLink="/application/consumer-auto" routerLinkActive="active">Personal Secured Asset Loan</button>
        <button mat-menu-item routerLink="/application/home-loan" routerLinkActive="active">Home Loan</button>
      </mat-menu>
      <button mat-button class="align-right" (click)="logout()">Logout</button>
    </nav>
  </mat-toolbar>
</header>

